import { saveRecord } from '@/entities/shared/record/save-record';
import type { ShoppingItem } from '../schemas/shopping-item';
import { shoppingItemSchema } from '../schemas/shopping-item';

export async function saveShoppingItem(id: string, data: Partial<ShoppingItem>): Promise<void> {
  await saveRecord('shopping', shoppingItemSchema, id, data);
}
